<script lang="ts">
    import { Img, Avatar } from "flowbite-svelte";
    import AbstractID, { userProfileAvailable } from "../AbstractID";
    import { displayNameOf, getAvatarColorClasses, getUserInitials } from "../Utilities";
    import site from "../site";

    import { createEventDispatcher } from "svelte";

    /** Clears the JWT and redirects to AbstractID to revoke the session. */
    const fnOnSignOut = () => AbstractID.signOut();

    /** Strips the AbstractID banner and links down to a single avatar row — for sidebar use. */
    export let minimal = false;
    /** When true, reduces card height and font sizes for inline usage. */
    export let compact = false;
    /** Whether to display the Account and Sign Out links at the bottom of the card. */
    export let showLinks = true;
    /** Enables cursor-pointer and hover ring to indicate the card is interactive. */
    export let clickable = true;

    const dispatcher = createEventDispatcher<{ click: void }>();

    let minimumCardHeight: number;
    $: {
        minimumCardHeight = minimal ? 20 : compact ? 80 : 100;
    }

    // Stable per-user background colour for initials-only mode (no profile picture).
    $: avatarColorClass = $userProfileAvailable ? "" : getAvatarColorClasses(AbstractID.tokenData?.userUUID);
</script>

<!-- svelte-ignore a11y-no-static-element-interactions -->
<!-- svelte-ignore a11y-click-events-have-key-events -->
<div
    class="w-[270px] max-w-[100%] {clickable ? 'cursor-pointer hover:ring' : ''} relative z-0 mt-8 rounded-lg bg-[length:128px_128px] p-1 outline outline-1 outline-offset-2 outline-zinc-300 dark:outline-zinc-700"
    style="min-height: {minimumCardHeight}px"
    on:click={() => dispatcher("click")}>
    {#if !minimal}
        <Img class="{compact ? 'max-h-[12px]' : 'max-h-[16px]'} mx-auto text-center opacity-90 dark:invert" src="/AbstractID-Logo.png" />
    {/if}

    <div class="flex items-center space-x-2 align-top {minimal ? 'text-xs' : compact ? 'mt-1' : 'mt-2'} zindex-10 relative {minimal ? '' : '-mb-1'}">
        <Avatar size={minimal ? 'sm' : 'md'} class="shrink-0 rounded-lg {avatarColorClass} {minimal ? 'text-xs' : ''}" src={$userProfileAvailable ? AbstractID.userProfilePictureURL : ""}>
            {getUserInitials(AbstractID.tokenData)}
        </Avatar>
        <div class="overflow-none w-full {minimal ? '' : 'pb-1'} font-normal text-gray-900 dark:text-white">
            <!-- Never the two name fields concatenated: an account created from an email alone
                 has neither, and that renders as a lone space above the address (§14). -->
            <div class="font-semibold">{displayNameOf(AbstractID.tokenData)}</div>
            <div class="text-xs dark:text-gray-300">{AbstractID.tokenData?.email}</div>
        </div>
    </div>

    {#if showLinks && !minimal}
        <div class="mt-4 whitespace-nowrap text-center text-sm text-gray-800 dark:text-gray-400">
            <div>
                <a class="mr-2 font-bold text-gray-700 hover:text-black hover:underline dark:text-gray-400 dark:hover:text-white" href={site.idBaseURL} target="_blank">Account</a>
                <!-- svelte-ignore a11y-no-static-element-interactions -->
                <!-- svelte-ignore a11y-click-events-have-key-events -->
                <a class="cursor-pointer font-bold text-gray-700 hover:text-black hover:underline dark:text-gray-400 dark:hover:text-white" id="sign-out" on:click={fnOnSignOut}>
                    Sign Out
                </a>
            </div>
        </div>
    {/if}
    <div class="absolute left-0 top-0 h-full w-full rounded-lg bg-zinc-200 dark:bg-zinc-800" style="z-index: -1" />
    <div class="absolute left-0 top-0 h-full w-full rounded-lg bg-repeat opacity-20 dark:invert" style="z-index: -1;background-image: url('/AbstractID-Tile-Dark.png')" />
</div>
